import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs/Rx';

import { MigalhasService } from 'app/shared/migalhas/migalhas.service';

import { Migalha } from 'models/migalha';
import { environment } from '../../environments/environment';
import { MenuLateralComponent } from 'app/restrito/shared/menu-lateral/menu-lateral.component';

@Component({
  selector: 'vestibular',
  templateUrl: './vestibular.component.html',
  styleUrls: ['./vestibular.component.scss'],
})
export class VestibularComponent implements OnInit, OnDestroy {

  environment = environment;

  baseMenuLateral = {
    nome: 'Vestibular',
    link: '/vestibular',
  };

  menuLateral = [
    { nome: 'Vestibular Ceuma', link: `/vestibular/ceuma` },
    { nome: 'Editais e Manuais', link: `/vestibular/editais-manuais` },
    { nome: 'Acompanhamento', link: '/vestibular/acompanhamento' },
    { nome: 'Resultados', link: `/vestibular/resultados` },
  ];

  url: BehaviorSubject<string> = new BehaviorSubject<string>('');

  inscricaoRota;

  migalhas = [];
  migalhasObs;

  constructor(
    private router: Router,
    private migalhasService: MigalhasService,
  ) {
    switch(environment.loginContexto){
      case 'EURO':
        this.menuLateral[0].nome = 'Vestibular Unieuro';
        break;
      case 'FAMAZ':
        this.menuLateral[0].nome = 'Vestibular Famaz';
        break;
      case 'CEUPI':
        this.menuLateral[0].nome = 'Vestibular Ceupi';
        break;
      case 'CESUP':
        this.menuLateral[0].nome = 'Vestibular Cesup';
        break;
      case 'Cesut':
        this.menuLateral[0].nome = 'Vestibular Cesut';
        break;
    }
    const migalhaRaiz = new Migalha(this.baseMenuLateral);
    migalhaRaiz.submenu = Migalha.construirArray(this.menuLateral);

    this.migalhasObs = this.migalhasService
      .iniciar([migalhaRaiz])
      .subscribe((dados) => {
        this.migalhas = dados;
      });

    this.inscricaoRota = router.events.subscribe((evento) => {
      if (evento instanceof NavigationEnd) {
        this.onNavegacaoURL(evento.url);
        this.migalhasService.novaUrl(evento.url);
      }
    });
    if (this.router.url === '/restrito/ceuma') {
      this.router.navigate(['login']);
    }
  }

  onNavegacaoURL(url) {
    this.url.next(url);
  }

  ngOnInit() { }

  ngOnDestroy() {
    if (this.inscricaoRota) {
      this.inscricaoRota.unsubscribe();
    }

    if (this.migalhasObs) {
      this.inscricaoRota.unsubscribe();
    }

  }
}
